import React, { Component } from 'react';
import IconInput from '../../components/icon-input';
import Sidebar from '../../components/sidebar';
import { withRouter } from 'react-router-dom';
import { Auth } from 'aws-amplify';
import './styles.css'

// this allows user to set a new password
class Changepwd extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  async changepwdHandler() {
    event.preventDefault();

    if (!this.isResetFormValid()) {
      return;
    }

    // AWS Cognito integration here

    try {
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(
        user,
        this.state.oldpassword,
        this.state.newpassword
      );
      this.props.history.push('/changepwdconfirm');
    } catch (error) {
      console.log(error);
    }
  } // changepwdHandler  

  isResetFormValid() {
    const { oldpassword, newpassword, newpasswordConfirmation } = this.state;
    const passwordRequirements = RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})');
    if (!oldpassword || !newpassword || !newpasswordConfirmation) {
      alert('Missing Fields: Please Fill Out All Missing Fields');
      return false;
    }
    if (newpassword !== newpasswordConfirmation) {
      alert('Missmatched Password: Please Make Sure Your Password Matches');
      return false;
    }
    if (!passwordRequirements.test(newpassword)) {
      alert('Missing Requirements: Password Must Be At Least 8 Characters And Contain At Least 1 Lowercase, 1 Uppercase, 1 Number, And 1 Special Character');
      return false;
    }
    return true;
  } // isResetFormValid

  render() {
    return (
      <div >
        <Sidebar />
        <div className='container-fluid my-container'>
          <div className="d-flex h-100 justify-content-center ">
            <div className="align-self-md-center h-auto w-40 p-4 form-container ">
              <p className="login-title">CHANGE PASSWORD</p>
              <IconInput icon='fa fa-lock' placeholder='OLD PASSWORD' type='password' value={this.state.oldpassword} onChange={(input) => this.setState({ oldpassword: input })} />
              <IconInput icon='fa fa-lock' placeholder='NEW PASSWORD' type='password' value={this.state.newpassword} onChange={(input) => this.setState({ newpassword: input })} />
              <IconInput icon='fa fa-lock' placeholder='CONFIRM YOUR PASSWORD' type='password' value={this.state.newpasswordConfirmation} onChange={(input) => this.setState({ newpasswordConfirmation: input })} />

              <button
                type='button'
                className='btn btn-info btn-block font-weight-bold'
                onClick={() => this.changepwdHandler()}
              >
                SUBMIT
          </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Changepwd);



// WEBPACK FOOTER //
// ./src/routes/changepwd/index.js